import api from '@/libs/axiosInstance';
import { useMutation } from '@tanstack/react-query';

export function useDeleteBulkEmailAttachment() {
  return useMutation({
    mutationFn: async (attachmentId: string): Promise<void> => {
      await api.delete(`/dashboard/affiliates/bulk-email/attachments/${attachmentId}`);
    },
  });
}
